import React, { forwardRef } from 'react';
import { Divider } from 'fronton-react';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { MagnifyingGlassIcon } from '@fronton/icons-react';
import { getSearchComboboxAriaProps, SEARCH_INPUT_ID } from './utils/search-suggestions-aria';
import {
  divider,
  searchbarInput,
  searchbarInputContainer,
  searchbarInputExpanded,
  searchbarInputIconDecoration,
} from './styles';
import { DATA_QA_DIVIDER, DATA_QA_SEARCH_INPUT } from './constants';

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputRef: React.RefObject<HTMLInputElement>;
  expanded: boolean;
  value: string;
  navigationIndex: number;
  listboxExpanded: boolean;
  collapse: () => void;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>((props, innerRef) => {
  const { expanded, navigationIndex, listboxExpanded, value, collapse, autoFocus, inputRef, ...rest } =
    props;

  const { t } = useTranslation();
  const comboboxAriaProps = getSearchComboboxAriaProps({ navigationIndex, listboxExpanded });

  return (
    <div className={searchbarInputContainer} ref={innerRef}>
      {!expanded && <MagnifyingGlassIcon className={searchbarInputIconDecoration} color="text-primary" />}
      <input
        ref={inputRef}
        form="headersearchform"
        className={cx(searchbarInput, expanded && searchbarInputExpanded)}
        type="search"
        name="q"
        value={value}
        {...rest}
        placeholder={t('header.searchbar.search')}
        aria-hidden={!expanded}
        tabIndex={expanded ? 0 : -1}
        aria-label={t('header.searchbar.search')}
        id={SEARCH_INPUT_ID}
        data-qa-header-search-input=""
        data-qa={DATA_QA_SEARCH_INPUT}
        autoComplete="off"
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
        {...comboboxAriaProps}
      />

      {expanded && <Divider data-qa={DATA_QA_DIVIDER} className={divider} />}
    </div>
  );
});
